import {
  AiChSettingsChangedMessage,
  AiChSuggestionMessage,
  OnlineCountWebsocketEvent,
  type OnlyFansChatDto,
  type OnlyFansMessage,
} from '@api'

import type { MessageQueue } from '@/modules/chatting/types.ts'

/**
 * TODO: should be reworked to use BE generated enums and payloads
 */
export enum PusherEvents {
  FAN_NUMBERING_STARTED_PROCESSING = 'fan_numbering_started_processing',
  FAN_NUMBERING_FINISHED_PROCESSING = 'fan_numbering_finished_processing',
  CHAT_MESSAGE_COUNTS = 'newMessageCounts',
  TOAST = 'toast',
  FAN_TYPING = 'fan-typing',
  UPDATED_MESSAGE = 'updated-message',
  ONLINE_COUNT_UPDATE = 'online-count-update',
  NOTIFICATION_COUNTS = 'notification-counts',
  UPDATED_QUEUE = 'updated-queue',
  PERMISSIONS_CHANGED = 'permissions-changed',
  AICH_SETTINGS_CHANGED = 'aich-settings-changed',
  AICH_SUGGESTION_GENERATED = 'aich_suggestion_generated',
  AICH_SUGGESTION_ACCEPTED = 'aich_suggestion_accepted',
}

export interface PusherEventPayload {
  [PusherEvents.FAN_NUMBERING_STARTED_PROCESSING]: {
    creatorId: number
  }
  [PusherEvents.FAN_NUMBERING_FINISHED_PROCESSING]: {
    creatorId: number
  }
  [PusherEvents.CHAT_MESSAGE_COUNTS]: {
    counts: Array<{
      creatorId: number
      chatMessagesCount: number
    }>
  }
  [PusherEvents.TOAST]: { type: string; text: string }
  [PusherEvents.FAN_TYPING]: { id: number }
  [PusherEvents.PERMISSIONS_CHANGED]: {
    userId: number
  }
  [PusherEvents.UPDATED_MESSAGE]: {
    chat?: OnlyFansChatDto
    message?: OnlyFansMessage
    userId?: number
    messageId?: number
    isLastMessage: boolean
  }
  [PusherEvents.ONLINE_COUNT_UPDATE]: OnlineCountWebsocketEvent
  [PusherEvents.NOTIFICATION_COUNTS]: unknown
  [PusherEvents.UPDATED_QUEUE]: {
    queueEntry: MessageQueue
    finished: boolean
  }
  [PusherEvents.AICH_SETTINGS_CHANGED]: AiChSettingsChangedMessage
  [PusherEvents.AICH_SUGGESTION_GENERATED]: AiChSuggestionMessage
  [PusherEvents.AICH_SUGGESTION_ACCEPTED]: { version: number; fanId: number }
}

type PusherHandlerAgs = {
  [E in keyof PusherEventPayload]: [event: E, data: PusherEventPayload[E]]
}[keyof PusherEventPayload]

export type PusherListener = (...args: PusherHandlerAgs) => void
